/**
 * Auto-scroll horizontal sections with progress bar
 * Used by: product-recommendations, featured-collection, categories, styled-by
 */
(function () {

  function initAutoScroll() {
    var scrollers = document.querySelectorAll('[data-auto-scroll]');

    scrollers.forEach(function (scroller) {
      // Skip if already initialized
      if (scroller.__autoScrollBound) return;
      scroller.__autoScrollBound = true;

      // Only auto-scroll on screens wider than 768px
      if (window.innerWidth <= 768) return;

      var rawSpeed = parseInt(scroller.getAttribute('data-scroll-speed'), 10) || 5;
      var speed = 0.3 + rawSpeed * 0.15;

      var section = scroller.closest('[data-auto-scroll-section]');
      if (!section) return;

      var track = section.querySelector('.auto-scroll-track');
      var thumb = track ? track.querySelector('.auto-scroll-thumb') : null;

      var paused = false;
      var userInteracting = false;
      var interactionTimer;

      // Clone all original children to create infinite loop
      var originalItems = Array.prototype.slice.call(scroller.children);
      var originalWidth = 0;

      // Wait a frame so layout is computed
      requestAnimationFrame(function () {
        // Measure the total width of original items (including gap)
        originalItems.forEach(function (item) {
          var style = window.getComputedStyle(item);
          originalWidth += item.offsetWidth + parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
        });

        // Account for gap between items
        var scrollerStyle = window.getComputedStyle(scroller);
        var gap = parseFloat(scrollerStyle.gap) || parseFloat(scrollerStyle.columnGap) || 0;
        originalWidth += gap * (originalItems.length);

        // Clone items to fill at least 2x the viewport
        var cloneSets = Math.ceil((scroller.clientWidth * 2) / originalWidth) + 1;
        for (var s = 0; s < cloneSets; s++) {
          originalItems.forEach(function (item) {
            var clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            scroller.appendChild(clone);
          });
        }
      });

      function updateProgress() {
        if (!thumb || !track) return;
        if (originalWidth <= 0) return;
        // Progress based on position within one set of original items
        var progress = (scroller.scrollLeft % originalWidth) / originalWidth;
        var trackW = track.offsetWidth;
        var thumbW = Math.max(trackW * 0.3, 20);
        var thumbL = progress * (trackW - thumbW);
        thumb.style.width = thumbW + 'px';
        thumb.style.left = thumbL + 'px';
      }

      function animate() {
        if (!paused && !userInteracting) {
          if (originalWidth > 0) {
            scroller.scrollLeft += speed;

            // When we've scrolled past one full set, jump back seamlessly
            if (scroller.scrollLeft >= originalWidth) {
              scroller.scrollLeft -= originalWidth;
            }
          }
        }
        updateProgress();
        requestAnimationFrame(animate);
      }

      // Pause on hover
      scroller.addEventListener('mouseenter', function () { paused = true; });
      scroller.addEventListener('mouseleave', function () { paused = false; });

      // Pause on touch interaction
      scroller.addEventListener('touchstart', function () {
        userInteracting = true;
      }, { passive: true });

      scroller.addEventListener('touchend', function () {
        clearTimeout(interactionTimer);
        interactionTimer = setTimeout(function () {
          userInteracting = false;
        }, 3000);
      });

      // Pause on mouse wheel
      scroller.addEventListener('wheel', function () {
        userInteracting = true;
        clearTimeout(interactionTimer);
        interactionTimer = setTimeout(function () {
          userInteracting = false;
        }, 3000);
      }, { passive: true });

      scroller.addEventListener('scroll', updateProgress, { passive: true });

      updateProgress();
      requestAnimationFrame(animate);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoScroll);
  } else {
    initAutoScroll();
  }

  // Expose globally so dynamic content can re-trigger
  window.initAutoScroll = initAutoScroll;

  // Re-run when Shopify loads a new section in theme editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAutoScroll);
  }

})();